import { render } from "./px-numeric-input.vue?vue&type=template&id=35ca9dc5&scoped=true&ts=true"
import script from "./px-numeric-input.vue?vue&type=script&lang=ts"
export * from "./px-numeric-input.vue?vue&type=script&lang=ts"

import "./px-numeric-input.vue?vue&type=style&index=0&id=35ca9dc5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ca9dc5"]])

export default __exports__